var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgNotificationsDrib = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 248,
  height: 248,
  viewBox: "0 0 248 248",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(89 85)"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "#F2BB00",
  fill: "#F2BB00",
  x: 0.5,
  y: 0.5,
  width: 69,
  height: 69,
  rx: 19
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#DCA100",
  x: 12.209,
  y: 20.454,
  width: 38.889,
  height: 38.889,
  rx: 18
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#FFF",
  x: 15.799,
  y: 15.069,
  width: 38.889,
  height: 38.889,
  rx: 18
}), /*#__PURE__*/React.createElement("path", {
  d: "M41 27H30a3 3 0 0 0-3 3v12.09a.973.973 0 0 0 1.599.744l2.53-2.13A3 3 0 0 1 33.061 40H41a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3Z",
  fill: "#DCA100"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#FFF",
  strokeWidth: 2,
  fill: "#F2BB00",
  cx: 43.743,
  cy: 28.217,
  r: 3
})), /*#__PURE__*/React.createElement("circle", {
  stroke: "#F2BB00",
  opacity: 0.134,
  cx: 124,
  cy: 124,
  r: 67.5
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#F2BB00",
  opacity: 0.134,
  cx: 124,
  cy: 124,
  r: 95.5
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#F2BB00",
  opacity: 0.134,
  cx: 124,
  cy: 124,
  r: 123.5
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M121 117h7M121 121h4"
}))));

export default SvgNotificationsDrib;